import type { RouteLocationNormalizedLoadedGeneric } from "vue-router";
import { createSharedComposable } from "@vueuse/core";
import { computed } from "vue";
import { useRoute } from "vue-router";

export function isEmbedPath(path: string) {
  return path.startsWith("/embed");
}

export function isEmbedRoute(route: RouteLocationNormalizedLoadedGeneric) {
  return isEmbedPath(route.path);
}

function useIsEmbedFn() {
  const route = useRoute();
  return computed(() => isEmbedRoute(route));
}

export const useIsEmbed = createSharedComposable(useIsEmbedFn);
